<template>
  <div class="container" ref="scrolltop" v-wechat-title="$route.meta.title= pageTitle">
    <barTitle :curUrlKey="curUrlKey" :titleText="titleText" :username="username" />
    <div class="top-cotainer">
      <inform :informList="informList" v-if="setting.top || informList !=''" />
      <banner :url="setting.pic_url" />
    </div>
    <!-- 倒计时 -->
    <countdown :setting="setting" />
    <!-- 已砍价列表 -->
    <div class="bargaining-list">
      <div class="bargaining-container">
        <template v-for="item in joinList">
          <bargaining-item
            :key="item.id"
            :item="item"
            :colorFirst="colorFirst"
            :setting="setting"
            @gotoBargain="gotoBargain(item)"
          />
        </template>
      </div>
    </div>
    <!-- 未砍价列表 -->
    <div class="notbargain-list">
      <div class="notbargain-container">
        <template v-for="item in notJoinList">
          <notBargaining-item
            :key="item.id"
            :item="item"
            :colorFirst="colorFirst"
            :currencySymbol="currencySymbol"
            :setting="setting"
            @gotoBargain="gotoBargain(item)"
          />
        </template>
      </div>
    </div>

    <div class="pagination" v-if="total > 10">
      <button class="page-btn" @click="prevPage">上一页</button>
      <button class="page-btn" @click="nextPage">下一页</button>
    </div>
  </div>
</template>

<script>
import wx from 'weixin-js-sdk';
import qs from 'qs';
import barTitle from "./components/Title";
import inform from "./components/Inform";
import banner from "./components/Banner";
import countdown from "./components/Countdown";
import bargainingItem from "./components/BargainingItem";
import notBargainingItem from "./components/NotBargainingItem";

export default {
  name: "bargainList",
  data() {
    return {
      pageTitle: "微砍价",
      titleText: "微砍价", // 标题文字
      curUrlKey: 'list',// 路径来源
      username: "", //	网站用户名
      zz_userid: "", // 登录用户ID
      zz_shellCode: "", // 登录用户验证码
      setting: {}, // 设置参数
      colorFirst: "",
      colorLast: "",
      currencySymbol: "",
      day: "00",
      hour: "00",
      minute: "00",
      second: "00",
      clearTimer: false,
      informList: [], // 滚动栏内容
      joinList: [], // 参与砍价商品的列表
      notJoinList: [], // 未参与砍价商品的列表
      page: 1, // 页码
      informTimer: null, // 滚动栏定时器
      domain: '',
      port: '',
      baseUrl: '',
      total: '',
      keyword: '',
      description: '',
      author: '',
      channel_share_info: null,
    };
  },
  components: {
    inform,
    banner,
    countdown,
    bargainingItem,
    notBargainingItem,
    barTitle
  },
  created(){
    if(document.location.protocol == 'https:') {
      this.port = ':12702'
    }else {
      this.port = ':12701'
    }
    this.domain = document.domain;
    // this.domain = "m.evyun.cn"
    this.baseUrl = this.domain + this.port
    
  },
  // 动态改变meta的值
  metaInfo(){
      return{
        meta: [
          { name: 'keyword', content: this.keyword },
          { name: 'description', content: this.description },
          { name: 'author', content: this.author }
        ]
      }
    },
  mounted() {
    // 获取cookie
    let cookieArg = this.getCookieStringArgs();
    // 获取query
    let queryArg = this.getQueryStringArgs();
    // 设置参数
    this.username = queryArg["username"];
    this.zz_userid = cookieArg["zz_userid"] ? cookieArg["zz_userid"] : 0;
    this.zz_shellCode = cookieArg["zz_shellCode"] ? cookieArg["zz_shellCode"] : 0;

    // 设置接口与成功信息接口参数
    const axparams = {
      username: this.username
    };
    // 活动列表数据参数
    const bargainListParams = {
      username: this.username,
      zz_userid: this.zz_userid,
      zz_shellCode: this.zz_shellCode
    };
    this.getMetaInfo();
    this.getListShareInfo();
    this.getSettingInfo(axparams);
    this.getSuccessInfo(axparams);
    this.getbargainListInfo(bargainListParams);
  },
  beforeDestroy() {
    // 组件销毁前清除定时器
    clearInterval(this.informTimer);
  },
  updated() {
    this._layer2my("closeAll", "loading");
  },
  methods: {
    // 点击商品按钮跳转路由
    gotoBargain(item) {
      const act_id = item.activity_id;
      const join_id = item.join_id;
      const username = this.username;
      if(item.can_purchase <= 0) {
        this._layer2my("msg", "活动指定商品或库存已告罄");
        return false
      }
      if (join_id) {
        this.$router.push({
          path: "/bargaining",
          query: { username,act_id, join_id  }
        });
      } else {
        this.$router.push({ path: "/bargaining", query: {  username,act_id } });
      }
    },
    // 下一页
    nextPage() {
      this.page++;
      const bargainListParams = {
        username: this.username,
        zz_userid: this.zz_userid,
        zz_shellCode: this.zz_shellCode,
        page: this.page
      };
      this.getbargainListInfo(bargainListParams);
    },
    // 上一页
    prevPage() {
      if (this.page > 1) {
        this.page--;
        const bargainListParams = {
          username: this.username,
          zz_userid: this.zz_userid,
          zz_shellCode: this.zz_shellCode,
          page: this.page
        };
        this.getbargainListInfo(bargainListParams);
      } else {
        this._layer2my("msg", "已经是第一页了哦~");
      }
    },
    // 获取接口
    // 获取[微砍价设置]接口
    getSettingInfo(axparams) {
      this.$axios
        .get(`//${this.baseUrl}/Frontend/Bargain/bargainSet`, { params: axparams })
        .then(this.getSettingInfoSuccess);
    },
    // 获取[活动砍价成功信息]接口
    getSuccessInfo(axparams) {
      this.$axios
        .get(`//${this.baseUrl}/Frontend/Bargain/joinSuccess`, { params: axparams })
        .then(this.getSuccessInfoSuccess);
    },
    // 获取[活动列表]接口
    getbargainListInfo(axparams) {
      this._layer2my("load");
      this.$axios
        .get(`//${this.baseUrl}/Frontend/Bargain/bargainList`, { params: axparams })
        .then(this.getbargainListInfoSuccess);
    },
    // 获取[meta相关]接口
    getMetaInfo() {
      const params = {
        username: this.username
      }
      this.$axios
        .get(`//${this.baseUrl}/Frontend/Bargain/bargainSeo`, { params })
        .then((res)=>{
          res = res.data;
          if (res.data && res.code == 200) {
            this.keyword = res.data.keywords;
            this.author = res.data.author;
            this.description = res.data.description;
            
          } else {
            this._layer2my("msg", res.msg);
          }
        });
    },
    // 获取接口成功后的回调
    // [微砍价设置]
    getSettingInfoSuccess(res) {
      const that = this;
      res = res.data;
      this._layer2my("closeAll", "loading");
      if (res.data && res.code == 200) {
        that.setting = res.data.list;
        that.currencySymbol = res.data.currencySymbol;
        switch (that.setting.color) {
          case 0:
            that.colorFirst = "#F61E1E";
            that.colorLast = "#F91808";
            break;
          case 1:
            that.colorFirst = "#0084FF";
            that.colorLast = "#00B4FF";
            break;
          case 2:
            that.colorFirst = "#FF9900";
            that.colorLast = "#FFBE32";
            break;
          case 3:
            that.colorFirst = "#0BB854";
            that.colorLast = "#54CD87";
            break;
          case 4:
            that.colorFirst = res.data.list.color_first;
            that.colorLast = res.data.list.color_second;
            break;
          default:
            that.colorFirst = "#F61E1E";
            that.colorLast = "#F91808";
            break;
        }
      } else {
        this._layer2my("msg", res.msg);
      }
    },
    // [活动砍价成功信息]
    getSuccessInfoSuccess(res) {
      res = res.data;
      this._layer2my("closeAll", "loading");
      if (res.data && res.code == 200) {
        res.data.list ? this.informList = res.data.list : [];
      } else {
        this._layer2my("msg", res.msg);
      }
    },
    // [活动列表]
    getbargainListInfoSuccess(res) {
      res = res.data;
      this._layer2my("closeAll", "loading");
      if (res.data && res.code == 200) {
        if (
          res.data.join_list == '' &&
          res.data.not_join_list == '' &&
          this.page != 1
        ) {
          this.page--;
          this._layer2my("msg", "没有更多数据了~");
        } else {
          this.joinList = res.data.join_list;
          this.notJoinList = res.data.not_join_list;
          this.$refs.scrolltop.scrollTop = 0;
          this.total = res.data.total;

        }
      } else {
        this._layer2my("msg", res.msg);
      }
    },
    // 分享信息接口 
    getListShareInfo(){
      let that = this;
      const axparams = {
        username: that.username
      };
      this.$axios
      .get(`//${this.baseUrl}/Frontend/Bargain/bargainChannelShare`, {
          params: axparams
        })
      .then(res=>{
        res = res.data;
        if (res.data && res.code == 200) {
          that.channel_share_info = res.data.channel_share_info;
          console.log(res.data.channel_share_info)
          that.getShareInfo()
        }
      })
    },
    // 微信分享
    getShareInfo() {
      const that = this;
      const params = {
        username: that.username
      };
      const share_info = that.channel_share_info;
      const title = share_info.share_title ? share_info.share_title : '微砍价';
      const pic = share_info.share_pic ? share_info.share_pic : that.setting.pic_url;
      const desc = share_info.share_des ? share_info.share_des : '点击进入列表页查看更多砍价商品~';
      this.$axios.post(`//${this.baseUrl}/Frontend/Bargain/bargainWxShare`,qs.stringify({
        username: that.username,
        url: location.href.split('#')[0]
      }),{
        headers: {'Content-Type': 'application/x-www-form-urlencoded'}
      }).then((res) => {
      let data = res.data.data.signPackage;
      wx.config({
        debug: false,
        appId: data.appId,
        timestamp: data.timestamp,
        nonceStr: data.nonceStr,
        signature: data.signature,
        jsApiList: ['updateAppMessageShareData', 'updateTimelineShareData']
      })
      }).catch((error) => {
        console.log(error)
      })
      wx.ready((res) => {
        wx.updateTimelineShareData({
          title: title,
          link: location.href,
          imgUrl: pic,
          success () {

          }
        });
        wx.updateAppMessageShareData({
          title: title,
          desc: desc,
          link: location.href,
          imgUrl: pic,
          success () {
          }
        })
      })
    },
    // 查询字符串参数
    getQueryStringArgs() {
      var qs = location.search.length > 0 ? location.search.substring(1) : "",
        args = {},
        items = qs.length > 0 ? qs.split("&") : [],
        item = null,
        name = null,
        value = null,
        i = 0,
        len = items.length;
      for (i; i < len; i++) {
        item = items[i].split("=");
        name = decodeURIComponent(item[0]);
        value = decodeURIComponent(item[1]);
        if (name.length) {
          args[name] = value;
        }
      }
      return args;
    },
    // 查询cookie参数
    getCookieStringArgs() {
      const cs = (document.cookie.length > 0 ? document.cookie.replace(/\s/g,"") : "");
      // const cs = this.getCookie().replace(/\s/g, ""); // 获取本地模拟cookies
      let args = {},
        items = cs.length > 0 ? cs.split(";") : [],
        item = null,
        name = null,
        value = null,
        i = 0,
        len = items.length;
      for (i; i < len; i++) {
        item = items[i].split("=");
        name = decodeURIComponent(item[0]);
        value = decodeURIComponent(item[1]);
        if (name.length) {
          args[name] = value;
        }
      }
      return args;
    },
    // 本地模拟获取cookie
    getCookie() {
      // 未登录
      // const cookies = "";
      // 别人
      // const cookies = "zz_userid=21263772;zz_shellCodeApi=%242y%2410%24.ehHpj9m25AlaZUynw9KQuCTYuc4s8kSOLllmGgpipAQqgr4CaC8S;zz_shellCodeApiTime=5dce191ee8864";
      // 自己
      const cookies = "zz_userid=21263772;zz_shellCode=c76676e680a08b9f0af490035b39396e";

      return cookies;
    },
    // 二次封装 layui
    _layer2my(type, str, cb, bargainParams) {
      layui.use("layer", function() {
        layer.ready(function() {
          switch (type) {
            case "msg":
              layer.msg(str, { time: 1500 });
              break;
            case "load":
              layer.load({
                shade: true
              });
              break;
            case "confirm":
              layer.confirm(
                str,
                {
                  btn: ["确定"]
                },
                function() {
                  cb && cb(bargainParams);
                  layer.closeAll();
                }
              );
              break;
            case "closeAll":
              layer.closeAll(str);
              break;
            default:
              layer.msg(str, { time: 1500 });
          }
        });
      });
    }
  }
};
</script>

<style scoped lang="scss">
.container {
  position: relative;
  margin: 0 auto;
  height: 100vh;
  background: #f8f8f8;
  overflow-x: hidden;

  .bargaining-list,
  .notbargain-list {
    margin-top: 0.2rem;
  }
  .notbargain-list {
    margin-bottom: 0.2rem;
  }
  .bargaining-container {
    border-radius: 0.2rem;
    width: 7.1rem;
    margin: 0 auto;
    overflow: hidden;
    > div:last-child .item {
      border-bottom: none;
    }
  }
  .notbargain-container {
    border-radius: 0.2rem;
    width: 7.1rem;
    margin: 0 auto;
    overflow: hidden;
  }
  .bargaining-container,
  .notbargain-container {
    > div >>> .item {
      border-bottom: 0.01rem solid #ededed;
    }
    > div:last-child >>> .item {
      border-bottom: none;
    }
  }
  .pagination {
    padding: 0 1.6rem;
    display: flex;
    justify-content: space-around;
  }
  .pagination .page-btn {
    width: 1.5rem;
    height: 0.8rem;
    border-radius: 0.12rem;
    background: #fff;
    border: 0.01rem solid #eee;
    font-size: 0.28rem;
    text-align: center;
    line-height: 0.8rem;
    margin-bottom: 0.2rem;
  }
}
.top-cotainer {
  position: relative;
}
</style>



// WEBPACK FOOTER //
// src/pages/Bargain/List.vue